import { render, staticRenderFns } from "./list-cancel-reject-form.vue?vue&type=template&id=2d8b68e3&"
import script from "./list-cancel-reject-form.vue?vue&type=script&lang=js&"
export * from "./list-cancel-reject-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports